import React, { Component } from 'react';
import _ from 'lodash';

import ReactDOM from 'react-dom';

import moment from 'moment';

import style from './style.scss';



import DeliveryStatisticsWithData from '../DeliveryStatisticsFIlter/DeliveryStatisticsWithData';
import DeliveryStatisticsFilter from '../DeliveryStatisticsFIlter/DeliveryStatisticsFilter';

export default class DeliveryStatisticsPage extends Component{

  constructor(props) {
    super(props);

    this.state = {
      filter_data: null,
    };

    this.onFilterChange = this.onFilterChange.bind(this);
  }


  componentWillMount(){

    const {app_data, history} = this.props;

    const role = app_data.roles[app_data.user.role_id];

    if(!role.access.delivery) {
      history.push(role.default_page);
    }

  }

  onFilterChange(data) {
    this.setState({
      filter_data: data
    });
  }

  onFilterInit() {

  }

  render() {

    const {app_data, history} = this.props;

    const {filter_data} = this.state;


    return (
      <div className={`container`}>

        <h1>Статистика доставок</h1>

        <DeliveryStatisticsFilter
          app_data={app_data}
          onFilterChange={this.onFilterChange}
        />

        {filter_data &&
          <DeliveryStatisticsWithData app_data={app_data} filter_data={filter_data} />
        }



      </div>
    );
  }
}

